import Vue from 'vue'
import Vuex from 'vuex'
import Checkout from './../classes/Checkout';
import { addsIdCustomFieldsOptions, uuidv4, isEqualFied } from './../helpers';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: null,
        design: '',
        idPurchase: null,
        ids: null,
        experiences: [],
        paymentMethods: [],
        idsLink: null,
        multiCalendar: false,
        dateSelected: null,
        checkout: null,
        showStepOne: false,
        showStepTwo: false,
        playersSelected: 0,
        calendarDays: {},
    },
    getters: {
        getToken: (state) => () => {
            return state.token;
        },
        getIdPurchase: (state) => () => {
            return state.idPurchase;
        },
        getIdsLink: (state) => () => {
            return state.idsLink;
        },
        getIds: (state) => () => {
            return state.ids;
        },
        getDateSelected: (state) => () => {
            return state.dateSelected;
        },
        getPaymentMethods: (state) => () => {
            return state.paymentMethods;
        },
        getMultiCalendar: (state) => () => {
            return state.multiCalendar
        },
        getState: (state) => () => {
            return state;
        },
        getCheckout: (state) => () => {
            return state.checkout
        },
        getExperiences: (state) => () => {
            return state.experiences
        },
        getDesign: (state) => () => {
            return state.design;
        },
        findFieldItems: (state) => ({ id_experience, title }) => {
            return state.checkout.items
                .filter(item => item.id_experience === id_experience)
                .flatMap(item => item.fields || []) // Aseguramos que `fields` sea un array
                .find(field => field.title === title);
        },
        getFieldItems: (state) => (payload) => {
            let fieldFinal = null;
            state.checkout.items.forEach((item) => {
                if (item.id_experience === payload.id_experience && item.id_calendario === payload.id_calendario) {
                    item.fields.map((filter) => {
                        if (filter.title === payload.title) {
                            fieldFinal = filter;
                        }
                    });
                }
            });

            return fieldFinal;
        },
        getNumPlayerItems: (state) => (payload) => {
            let number = null;
            state.checkout.items.forEach((item) => {
                if (item.id_experience === payload.id_experience && item.id_calendario === payload.id_calendario) {
                    number = item.people_number;
                }
            });

            return number;
        },
        getNumPlayerMinimalItems: (state) => (payload) => {
            let number = 0;
            state.checkout.items.forEach((item) => {
                if (item.id_experience == payload.id_experience) {
                    number += parseInt(item.people_number);
                }
            });

            return number;
        },
        getExperiencesCheckout: (state) => () => {
            return state.checkout.items.map(item => {
                return state.experiences.find(experience => experience.id === item.id_experience);
            });
        },
        isMultiPrice: (state) => () => {
            return state.isMultiple;
        },
        getPlayersSelected: (state) => () => {
            return state.playersSelected;
        },
        getDisplayMode: (state) => () => {
            return state.displayMode;
        },
        getBlockView: (state) => () => {
            return state.blockView;
        },
        canShowStepOne: (state) => () => {
            return state.showStepOne;
        },
        canShowStepTwo: (state) => () => {
            return state.showStepTwo;
        },
        isMinimal: (state) => () => {
            return state.displayMode === 'minimal';
        },
        getCalendarDays: (state) => () => {
            return state.calendarDays;
        },
    },
    mutations: {
        refreshState: (state) => {
            state.checkout.id = null;
            state.checkout.items = [];
            state.checkout.code = null;
            state.multiCalendar = false;
        },
        updateToken: (state, payload) => {
            state.token = payload.token;
        },
        updateIdPurchase: (state, payload) => {
            state.idPurchase = payload.idPurchase;
        },
        updatePaymentsMethods: (state, payload) => {
            state.paymentMethods = payload.paymentMethods;
        },
        updateIdsLinks: (state, payload) => {
            state.idsLink = JSON.parse(payload.idsLink);
        },
        updateDesign: (state, payload) => {
            state.design = payload.design;
        },
        updateIds: (state, payload) => {
            state.ids = payload.ids;
        },
        updateExperiences: (state, payload) => {
            state.experiences = addsIdCustomFieldsOptions(payload.experiences);
        },
        updateDateSelected: (state, payload) => {
            state.dateSelected = payload.dateSelected;
            state.multiCalendar = false;

            if (!payload.notUpdateCheckout) {
                state.checkout = new Checkout();
            }
        },
        udpateMultiCalendar: (state) => {
            state.multiCalendar = !state.multiCalendar;
            state.checkout = new Checkout();
        },
        addItem: (state, payload) => {
            state.checkout.items.push(payload.item);
        },
        changeItem: (state, payload) => {
            state.checkout.items = [payload.item];
        },
        removeItem: (state, payload) => {
            state.checkout.items = state.checkout.items.filter(item => JSON.stringify(item) !== JSON.stringify(payload.item))
        },
        removeItems: (state) => {
            state.checkout.items = [];
        },
        removeMinimalItem: (state) => {
            let item = state.checkout.items[0];
            state.checkout.items = [item];
            state.checkout.items.map((item) => {
                item.start = null;
                item.end = null;
            });
        },
        updateCheckout: (state, payload) => {
            let code = '';
            if (state.checkout) code = state.checkout.code;
            state.checkout = payload.checkout;
            state.checkout.code = code;
        },
        updateCheckoutStatus: (state, payload) => {
            state.status = payload.status;
        },
        updateCheckoutPartial: (state, payload) => {
            state.checkout.is_fractioned = payload.is_fractioned;
        },
        updateCheckoutField: (state, payload) => {
            state.checkout[payload.name] = payload.value;

            state.checkout.items.forEach((item) => {
                let experience = state.experiences.find(experience => experience.id === item.id_experience);

                if (!experience) return;

                if (experience.price_type === 'multi_price') {
                    /*
                    Solo si es de tipo multiprice se sincronzan los idiomas dentro de cada item
                    */
                    item.language = payload.value;
                }
            })

        },
        updatePeopleNumber: (state, payload) => {
            state.checkout.items.forEach((item) => {
                if (item.id_experience === payload.id_experience && item.id_calendario === payload.id_calendario && item.start === payload.start) {
                    item.people_number = payload.people;
                    item.price_original = payload.price;
                }
            });
        },
        updateItemOpenSession: (state, payload) => {
            state.checkout.items.forEach((item) => {
                if (item.id_experience === payload.id_experience && item.id_calendario === payload.id_calendario && item.start === payload.start) {
                    item.open_session = payload.open_session;
                }
            });
        },
        updateItemField: (state, payload) => {
            /* 
            Cómo deben descomponerse los datos que se pasan al backend

            - NO MULTIPRICE

            1. Para reservas NO MULTIPRICE, cada item se trata de forma individual, con su propio ID.
            2. Siguiendo la convención, se pasa el valor de cada campo, no el cálculo final (por seguridad).
            3. Para campos de tipo +=, el precio se reparte entre el número total de items, 
            y cada uno de estos campos lleva su propio ID dentro de cada item.
            5. Los IDs los genera el frontend, pero deben mantenerse persistentes entre actualizaciones.

            - MULTIPRICE

            1. El primer item debe incluir todos los IDs de los campos.
            2. A partir del segundo item, solo deben llevar IDs los campos de tipo +=.
            3. El precio de los campos += se reparte entre el total de items.
            4. Se pasa el valor individual del campo (no el total), para evitar errores de cálculo en el backend.
            5. El cálculo del total final se realiza correctamente en el backend.
            6. Los IDs de los campos los crea el frontend y deben mantenerse consistentes entre actualizaciones.

            - SOBRE EL ESTADO

            Es muy importante que esta parte del estado mantenga siempre la misma estructura.
            Se debe tener especial cuidado en las operaciones de postPurchase y patchPurchase, ya que el backend puede enviar una estructura diferente.
            Esa estructura debe reconciliarse con la del estado del frontend.
            La primera vez que se envían los datos, los items deben identificarse por el campo `title`.
            A partir de las siguientes actualizaciones, se debe utilizar el campo `id_custom_fields_options`,
            el cual solo se incluye en los campos que modifican el precio.
            Esto asegura una correcta vinculación entre los datos recibidos del backend y el estado local.
            */


            state.checkout.items.forEach((item) => {
                if (item.id_experience === payload.id_experience && item.id_calendario === payload.id_calendario && item.start === payload.start) {
                    let find = false;
                    item.fields.forEach((filter) => {
                        // ahora se idenfica el campo id_custom_fields_options y el title como lo hace le backend, es mejor usar una clave compuesta
                        if (isEqualFied(filter, payload.newField)) {
                            find = true;
                            filter.value = payload.newField.value;
                            filter.name = payload.newField.name;
                            filter.amount = payload.newField.amount;
                            filter.total = payload.newField.total ?? payload.newField.amount;
                            // Para evitar que cree nuevos ingles no se debe de agreagar el id del newField pero si es de tipo += se debe de agregar en la función adaptRequest
                            filter.id_custom_fields_options = payload.newField.id_custom_fields_options;


                            /*
                            PARA MULIPRICE Y NO MULTIPRICE
                            Para los campos de tipo += los icampos a partir del segundo item
                            deben de llevar id pero no debe ser el mismo que del primer item 
                            pero en siguentes peticiones debe de mantenerse
                            */
                            if (!filter.id) {
                                filter.id = payload.newField.id;
                            }
                        }
                    });

                    if (!find) {
                        item.fields.push(payload.newField);
                    }
                }
            });

            // Si es para los casos "+" o "+*" no se deBe de repartir los valores
            if (payload.newField.name.includes('+*') || /.*\+\d+(?:[.,]\d{1,2})?/g.test(payload.newField.name)) {
                return
            }

            /*
            por como funciona el backend se debe de actualizar el precio repartiendo entre el numero de items los que son de tipo selsect con +=
            */
            if (payload.newField.type === "select") {
                let price = 0;
                let realPrice = 0;

                if (payload.newField.name.includes("+=")) {
                    price = payload.newField.amount ?? payload.newField.total;
                    realPrice = price / state.checkout.items.length;
                }


                state.checkout.items.forEach((item) => {

                    let experience = state.experiences.find(selectedItem => selectedItem.id === item.id_experience);
                    let isNotMultiprice = experience?.price_type !== 'multi_price';

                    // Si no es multiprice, solo actúa sobre el item que coincide con la experiencia, calendario y hora
                    if (
                        isNotMultiprice &&
                        !payload.newField.name.includes("+=") && // Para los campos += si se debe de añadir el campo
                        (item.id_experience !== payload.id_experience ||
                            item.id_calendario !== payload.id_calendario ||
                            item.start !== payload.start)
                    ) {
                        return; // saltar este item si no coincide
                    }

                    // Es necesario identificar el campo para preservar el id si existe
                    let existingField = item.fields.find(f => {
                        if (payload.newField?.id_custom_fields_options) {
                            return isEqualFied(f, payload.newField)
                        }
                        return (
                            f.title === payload.newField.title &&
                            f.type === payload.newField.type
                        );
                    });

                    const preservedId = existingField?.id ?? uuidv4();


                    const dataToUpdate = {
                        /*
                        En el item qeu se añade se debe de generar SOLO SI NO ES MULTI PRICE se deben de copiar los datos como los el id_custom_fields_options y crear un nuevo uuid
                        QUE SE DEBE DE MANTENER ENTRE ACTUALIZACIONES
                        */
                        ...(isNotMultiprice ? {
                            ...payload.newField,
                            id: preservedId // Gener aun uid unico porque el backend no acepta el mismo que ya tiene y lanza un error, esto pasa porque los campos de += solo se añaden en el formulario una vez y en el fomrulario creran el uuid
                        } : {}),
                        amount: realPrice,
                        total: realPrice,
                        name: payload.newField.name,
                        title: payload.newField.title,
                        value: payload.newField.value,
                        type: payload.newField.type,
                    }

                    // Actualiza los existentes con los nuevos valores
                    item.fields.forEach(filed => {
                        if (filed.title === dataToUpdate.title && filed.type === dataToUpdate.type) {
                            filed.amount = dataToUpdate.amount;
                            filed.total = dataToUpdate.total;
                            filed.name = dataToUpdate.name;
                            filed.title = dataToUpdate.title;
                            filed.value = dataToUpdate.value;
                        }
                    })

                    // Existe un caso en el que no tiene ese campo entonces se tiene que añadir
                    if (!item.fields.some(filed => filed.title === dataToUpdate.title && filed.type === dataToUpdate.type)) {
                        item.fields.push(dataToUpdate);
                    }
                })
            }

            // Para los campos de no cuando no es multirpice denem de ir en los items porque son individuales
            if (payload.newField.type === "select" && payload.newField.value.toLowerCase().includes("no")) {
                state.checkout.items.forEach((item) => {

                    let experience = state.experiences.find(selectedItem => selectedItem.id === item.id_experience);
                    let isMultiprice = experience?.price_type === 'multi_price';

                    if (isMultiprice) {
                        return;
                    }

                    // Es necesario identificar el campo para preservar el id si existe
                    let existingField = item.fields.find(f => {
                        if (payload.newField?.id_custom_fields_options) {
                            return isEqualFied(f, payload.newField);
                        }
                        return (
                            f.title === payload.newField.title &&
                            f.type === payload.newField.type
                        );
                    });

                    const preservedId = existingField?.id ?? uuidv4();


                    const dataToUpdate = {
                        /*
                        En el item qeu se añade se debe de generar SOLO SI NO ES MULTI PRICE se deben de copiar los datos como los el id_custom_fields_options y crear un nuevo uuid
                        QUE SE DEBE DE MANTENER ENTRE ACTUALIZACIONES
                        */
                        ...(!isMultiprice ? {
                            ...payload.newField,
                            id: preservedId // Gener aun uid unico porque el backend no acepta el mismo que ya tiene y lanza un error, esto pasa porque los campos de += solo se añaden en el formulario una vez y en el fomrulario creran el uuid
                        } : {}),
                        amount: payload.newField.amount,
                        total: payload.newField.total,
                        name: payload.newField.name,
                        title: payload.newField.title,
                        value: payload.newField.value,
                        type: payload.newField.type,
                        id_custom_fields_options: payload?.newField?.id_custom_fields_options
                    }

                    // Actualiza los existentes con los nuevos valores
                    item.fields.forEach(filed => {

                        if (filed.title === dataToUpdate.title && filed.type === dataToUpdate.type) {
                            filed.amount = dataToUpdate.amount;
                            filed.total = dataToUpdate.total;
                            filed.name = dataToUpdate.name;
                            filed.title = dataToUpdate.title;
                            filed.value = dataToUpdate.value;
                        }
                    })

                    // Existe un caso en el que no tiene ese campo entonces se tiene que añadir
                    if (!item.fields.some(filed => filed.title === dataToUpdate.title && filed.type === dataToUpdate.type)) {
                        item.fields.push(dataToUpdate);
                    }
                })
            }

            console.log('checkout updated', state.checkout);
        },
        updateIsMultiplePrice: (state, payload) => {
            state.isMultiple = payload.experiences && payload.experiences.length && payload.experiences.every(exp => exp.price_type === 'multi_price');
        },
        updatePlayersSelected: (state, payload) => {
            state.playersSelected = payload;
        },
        updateDisplayMode: (state, payload) => {
            state.displayMode = payload;
        },
        updateBlockView: (state, payload) => {
            state.blockView = payload;
        },
        updateShowStepOne: (state, payload) => {
            state.showStepOne = payload;
        },
        updateShowStepTwo: (state, payload) => {
            state.showStepTwo = payload;
        },
        updateCheckoutItemsLanguage: (state, language) => {
            state.checkout.items = state.checkout.items.map((item) => ({ ...item, language }))
        },
        updateCalendarDays: (state, payload) => {
            state.calendarDays = payload.days;
        },
    },
    actions: {},
    modules: {}
})
